module.exports = __webpack_public_path__ + "media/images/pc/articles/report_02-bdb8f76648c6448dda6dae9426235e22.webp";